
import { defineComponent, computed } from "vue";
import Loader from "@/views/Components/Loader.vue";
import RoomModal from "./RoomModal.vue";
import SingleRoomModal from "./SingleRoomModal.vue";
import SettingsModal from "../GameScreen/SettingsModal.vue";
import DonateModal from "../GameScreen/DonateModal.vue";
import Login from "./LoginModal.vue";
import MaintenanceMode from "./MaintenanceMode.vue";
import { useStore } from "../../stores";
import { ActionTypes } from "../../stores/action-types";
import AppConfig from "../../config/app-config";
import router from "@/router";
import { LoggedOutPlayer } from "@/protocol/dto/logged-out-player";
import gameApplication from "../../game/game-app";
import HelpModal from "../GameScreen/HelpModal.vue";

export default defineComponent({
  data: () => ({
    progress: 0,
    homePage: AppConfig.WEB_SITE_HOME_PAGE,

    // Main game modals.
    isSettingsShown: false,
    isHelpShown: false,
    isDonateShown: false,

    // This determines if one of the multiplayer game icons has been clicked
    // i.e. all of the games except the practice game.
    isGameSelected: false,
    
    gameModes: [
      {
        id: "PRACTICE",
        label: "Practice<br/>table",
        image: "/images/buttons/ball5.png",
      },
      {
        id: "POOL8",
        label: "Play<br/>8 ball pool",
        image: "/images/buttons/ball4.png",
      },
      {
        id: "POOL9",
        label: "Play<br/>9 ball pool",
        image: "/images/buttons/ball3.png",
      },
      {
        id: "POOL8UK",
        label: "Play<br/>UK 8 ball pool",
        image: "/images/buttons/ball1.png",
      },
      {
        id: "SNOOKER",
        label: "Play<br/>regular snooker",
        image: "/images/buttons/ball2.png",
      },
      {
        id: "SNOOKER6",
        label: "Play<br/>6 red snooker",
        image: "/images/buttons/ball2.png",
      },
    ],
  }),

  setup() {
    const store = useStore();
    const user = computed(() => store.state.user);
    const roomsCount = computed(() => store.state.rooms.length);
    const isLoginShown = computed(() => store.state.isLoginShown);
    const isRoomsShown = computed(() => store.state.isRoomsShown);
    const isMaintenanceMode = computed(() => AppConfig.MAINTENANCE_MODE);

    let amountOfRooms = roomsCount.value;

    return { user, isLoginShown, isRoomsShown, isMaintenanceMode, amountOfRooms };
  },

  beforeMount() {
    document.title = 'Booza Games - Play Pool and Snooker With Friends';
  },

  mounted() {
    const progressInterval = setInterval(() => {
      if (this.progress === 100) {
        clearInterval(progressInterval);
        return;
      }
      this.progress += 10;
    }, 200);
  },

  methods: {
    closeRoomsModal(): void {
      const store = useStore();
      this.isGameSelected = false;
      store.dispatch(ActionTypes.ROOMS_SHOWN, false);
    },

    onSelectGame(game: any): void {
      const store = useStore();
      
      if (game && game.id) {
        if (game.id === 'PRACTICE') {
          this.isGameSelected = false; // the rooms list not shown
          store.dispatch(ActionTypes.SELECT_GAME, game.id);
          router.push({ name: 'game', query: { mode: 'practice' } });
        } else if (game.id.indexOf('NA') > -1) {
          this.isGameSelected = false;
          alert("This option is not implemented. Please select another option.");
        } else {
          this.isGameSelected = true;
          store.dispatch(ActionTypes.SELECT_GAME, game.id);
        }
      }
    },

    logout(): void {
      const store = useStore();
      const user: LoggedOutPlayer = {
        username: gameApplication.getPlayer().playerId,      
      };
      store.dispatch(ActionTypes.USER_LOGOUT, user);
      window.location.href = AppConfig.WEB_SITE_HOME_PAGE;
    }
  },

  components: { Login, MaintenanceMode, Loader, RoomModal, SingleRoomModal, SettingsModal, HelpModal, DonateModal},
});
